import { USER_ROUTES } from "../constants/routes";
import { UserRole } from "../types/AppModel";
import { RegisterFormModel } from "../types/RegisterFormModel";
import api from "./api";

export const validateInvitationToken = async (token: string) => {
  try {
    const response = await api.post("users/validate-invitation-token", {
      token,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Failed to validation invitation, please contact admin",
      error
    );
    throw error;
  }
};

export const registerUser = async (formValue: RegisterFormModel) => {
  try {
    const response = await api.post("users/register", formValue);
    return response.data;
  } catch (error) {
    console.error("Registration failed, please contact admin", error);
    throw error;
  }
};

export const getUserProfile = async () => {
  try {
    const response = await api.get("users/profile");
    return response.data;
  } catch (error) {
    console.error("Get user profile failed, please contact admin", error);
    throw error;
  }
};

export const signInSuccessRedirectLink = (role: UserRole) => {
  //special condition for students just signed up and not finished placement test

  // return USER_ROUTES[role] || "";

  return "";
};
